import { render, staticRenderFns } from "./mini-stat.html?vue&type=template&id=5d536972&scoped=true&"
import script from "./mini-stat.js?vue&type=script&lang=js&"
export * from "./mini-stat.js?vue&type=script&lang=js&"
import style0 from "./mini-stat.scss?vue&type=style&index=0&id=5d536972&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d536972",
  null
  
)

export default component.exports